var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.isDisplayExpirationSessionPopup
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "my-5 xl:my-15"
  }, [_c('h3', {
    staticClass: "mb-5 md:mb-10 2xl:mb-15"
  }, [_vm._v("\n      Votre session va expirer\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mb-10"
  }, [_c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n        Vos données n'ont pas été sauvegardées depuis longtemps.\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n        Pensez à les sauvegarder pour éviter toute perte d'information\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center bg-pink"
  }, [_c('action-button', {
    staticClass: "mr-4",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "type-shadow": "shadow-pink",
      "libelle": "OK"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.resetSessionTimer();
      }
    }
  })], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }